import { render, staticRenderFns } from "./newlyAddress.vue?vue&type=template&id=6903266d&"
import script from "./newlyAddress.vue?vue&type=script&lang=js&"
export * from "./newlyAddress.vue?vue&type=script&lang=js&"
import style0 from "./newlyAddress.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports